import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: () => import('../views/index')
  },
  {
    path: '/index',
    name: '首页',
    component: () => import('../views/index')
  },
  {
    path: '/summary',
    name: '会社概要',
    component: () => import('../views/summary')
  },

  {
    path: '/culture',
    name: '企業沿革',
    component: () => import('../views/culture')
  },
  {
    path: '/content',
    name: '事業内容',
    component: () => import('../views/content')
  },

  {
    path: '/product',
    name: '取扱商品',
    component: () => import('../views/product')
  },
  {
    path: '/future',
    name: '未来展望',
    component: () => import('../views/future')
  },

  {
    path: '/contact',
    name: '連絡先',
    component: () => import('../views/contact')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
